<script>
    import TrackingStatusMethods from '../$methods/tracking-status.methods.js'

    export let label = ''
    /** success | warning | danger | info | neutral — si no se pasa, se infiere de label */
    export let variant = null

    $: resolvedVariant = variant || TrackingStatusMethods.variant(label)
</script>

<span class="table-status table-status--{resolvedVariant}">
    <span class="table-status__dot" aria-hidden="true"></span>
    <span>{label}</span>
</span>
